import { redirect, reload, getParam } from '../utils/common'

export default {
  redirect,
  reload,
  getParam,
  referrer: global.document && global.document.referrer,
  global: global.location
}
